// Cross-open localStorage caching (app market apps/offerings, geo) is enabled only
// in production. In automation/integration (and local dev) it stays off so E2E tests
// and developers always see live, unmocked data instead of a stale cached copy.
export const isPersistentCacheEnabled = () => window.vue_config?.VUE_APP_ENV === 'production';
